"use strict";

exports.__esModule = true;
exports.isStaffVariant = exports.isDurationVariant = exports.isCustomVariant = exports.getVariantType = exports.getStaffVariantsFromAllVariants = void 0;
var _types = require("@wix/ambassador-bookings-catalog-v1-service-options-and-variants/types");
const getVariantType = serviceVariants => {
  var _serviceVariants$opti;
  return serviceVariants == null || (_serviceVariants$opti = serviceVariants.options) == null || (_serviceVariants$opti = _serviceVariants$opti.values) == null || (_serviceVariants$opti = _serviceVariants$opti[0]) == null ? void 0 : _serviceVariants$opti.type;
};
exports.getVariantType = getVariantType;
const isStaffVariant = serviceVariants => {
  return getVariantType(serviceVariants) === _types.ServiceOptionType.STAFF_MEMBER;
};
exports.isStaffVariant = isStaffVariant;
const isCustomVariant = serviceVariants => {
  return getVariantType(serviceVariants) === _types.ServiceOptionType.CUSTOM;
};
exports.isCustomVariant = isCustomVariant;
const isDurationVariant = serviceVariants => {
  return getVariantType(serviceVariants) === _types.ServiceOptionType.DURATION;
};
exports.isDurationVariant = isDurationVariant;
const getStaffVariantsFromAllVariants = (service, optionsAndVariants) => {
  var _optionsAndVariants$o, _optionsAndVariants$v;
  if (!service || (optionsAndVariants == null ? void 0 : optionsAndVariants.serviceId) !== service.id) {
    return;
  }
  const staffVariants = {};
  const staffOptionId = optionsAndVariants == null || (_optionsAndVariants$o = optionsAndVariants.options) == null || (_optionsAndVariants$o = _optionsAndVariants$o.values) == null || (_optionsAndVariants$o = _optionsAndVariants$o[0]) == null ? void 0 : _optionsAndVariants$o.id;
  if (!staffOptionId || !isStaffVariant(optionsAndVariants)) {
    return;
  }
  optionsAndVariants == null || (_optionsAndVariants$v = optionsAndVariants.variants) == null || (_optionsAndVariants$v = _optionsAndVariants$v.values) == null || _optionsAndVariants$v.forEach(variant => {
    var _variant$choices;
    (_variant$choices = variant.choices) == null || _variant$choices.forEach(choice => {
      if (choice.optionId === staffOptionId) {
        staffVariants[choice.staffMemberId] = variant.price;
      }
    });
  });
  return {
    variants: staffVariants
  };
};
exports.getStaffVariantsFromAllVariants = getStaffVariantsFromAllVariants;
//# sourceMappingURL=serviceOptionsAndVariants.js.map